import { all, put, takeEvery } from "redux-saga/effects";
import { getPicture, updateCapture } from "../../Services/database";
import { setErrorStatus } from "../status/action";
import { getFileUrl } from "../../Services/storage";
import store from "../store";

export const actionTypes = {
  SET_CAPTURES: "SET_CAPTURES",
  GET_REFERENCE_IMAGE: "GET_REFERENCE_IMAGE",
  SET_OFFLINE_CAPTURES: "SET_OFFLINE_CAPTURES",
  UPDATE_CAPTURE_PICTURE: "UPDATE_CAPTURE_PICTURE",
  REVERT_CAPTURE_PICTURE: "REVERT_CAPTURE_PICTURE"
};

function* updateCapturePictureWorker(action) {
  try {
    yield setFaceComparisonLoading(true);

    const captures = store.getState().faceComparison.captures;
    const data = {
      approval: {
        status: "PENDING",
        updatedAt: +new Date(),
        ...(captures?.[action.payload?.data?.capturedId]?.approval?.geoContext
          ? {
              geoContext:
                captures?.[action.payload.data.capturedId].approval.geoContext
            }
          : {})
      },
      name: action.payload.data.name,
      employee: action.payload.data.employee,
      updateReference: false,
      success: false
    };

    yield updateCapture(action.payload.data.capturedId, data);

    action.payload.navigate("/faceIdentification/uploadReference/success");

    yield setFaceComparisonLoading(false);
  } catch (error) {
    setErrorStatus(error, "updateCapturePictureWorker");
    yield setFaceComparisonLoading(false);
  }
}

function* revertCapturePictureWorker(action) {
  try {
    yield setFaceComparisonLoading(true);

    const data = {
      approval: {
        status: "PENDING"
      },
      name: action.payload.data.name,
      employee: action.payload.data.employee,
      updateReference: false,
      success: false
    };

    yield updateCapture(action.payload.data.capturedId, data);

    action.payload.navigate("/");

    yield setFaceComparisonLoading(false);
  } catch (error) {
    setErrorStatus(error, "revertCapturePictureWorker");
    yield setFaceComparisonLoading(false);
  }
}

function* setCaptureWorker(action) {
  try {
    yield setFaceComparisonLoading(true);

    const capturesObj = action.payload.data;
    yield put({
      type: "PUT_CAPTURE",
      payload: capturesObj
    });

    const entries = Object.entries(capturesObj);
    const updatedCapturesObj = {};

    for (let [, [key, capture]] of entries.entries()) {
      try {
        const fileUrl = yield getFileUrl(capture.asset);
        updatedCapturesObj[key] = {
          ...capture,
          fileUrl: fileUrl?.url
        };
      } catch (error) {
        console.error(`Error fetching file URL for ${key}:`, error);
        updatedCapturesObj[key] = {
          ...capture
        };
      }
    }

    yield put({
      type: "UPDATE_CAPTURE_WITH_ASSETS",
      payload: updatedCapturesObj
    });
    yield setFaceComparisonLoading(false);
  } catch (error) {
    yield setFaceComparisonLoading(false);

    setErrorStatus(error, "setCaptureWorker");
  }
}

function* setOfflineCapturesWorker(action) {
  yield put({
    type: "PUT_OFFLINE_CAPTURES",
    payload: action.payload.data
  });
}

function* getReferenceImageWorker(action) {
  try {
    yield setFaceComparisonLoading(true);
    const { documentId, reference } = action.payload.data;

    if (!reference) {
      yield setFaceComparisonLoading(false);
      return;
    }
    let updatedReference = [];
    for (let i = 0; i < reference.length; i++) {
      const data = reference[i];
      if (data.fileUrl) {
        continue;
      }
      const pictureData = yield getPicture(data.pictureId);
      if (pictureData?.asset) {
        const fileUrl = yield getFileUrl(pictureData?.asset);
        updatedReference.push({ ...data, fileUrl: fileUrl?.url });
      }
    }

    const captures = store.getState().faceComparison.captures;
    captures[documentId].reference = updatedReference;

    yield put({
      type: "PUT_CAPTURE",
      payload: captures
    });
    yield setFaceComparisonLoading(false);
  } catch (error) {
    yield setFaceComparisonLoading(false);
    setErrorStatus(error, "getReferenceImageWorker");
  }
}

export default function* faceComparisonWatcher() {
  yield all([
    takeEvery("SET_CAPTURES", setCaptureWorker),
    takeEvery("GET_REFERENCE_IMAGE", getReferenceImageWorker),
    takeEvery("SET_OFFLINE_CAPTURES", setOfflineCapturesWorker),
    takeEvery("UPDATE_CAPTURE_PICTURE", updateCapturePictureWorker),
    takeEvery("REVERT_CAPTURE_PICTURE", revertCapturePictureWorker)
  ]);
}

function* setFaceComparisonLoading(bool) {
  yield put({
    type: "SET_FACE_COMPARISON_LOADING",
    payload: {
      loading: bool
    }
  });
}
